import './formLayout.less';

import React, { PropsWithChildren } from 'react';
import classes from 'classnames';
import b_ from 'b_';

const b = b_.with('form-layout');

// the stylesheet lays out 2 and 3 columns; a form builder may ask for any number
export type FormLayoutType = '1-column' | `${number}-columns`;

export type FormLayoutProps = PropsWithChildren<{
	type?: FormLayoutType;
	containerClass?: string;
}>;

export const FormLayout = ({ type = '1-column', containerClass, children }: FormLayoutProps) => (
	<div className={classes(b({ [type]: true }), containerClass)}>{children}</div>
);

export default FormLayout;
